/* global Modernizr */

import { Controller } from 'stimulus';
import throttle from '../helpers/throttle';

const COLLAPSED_CLASS = 'is-collapsed';
const ANIMATION_SPEED = 300;
const COLLAPSED_WIDTH = 70;
const EXPANDED_OPACITY = 0.75;

class Header extends Controller {
  connect() {
    this.$navToggler = $('.js-navigation-toggler');

    if (Modernizr.mq('(min-width: 992px)')) {
      this.navWidth = $(this.navigationTarget).width();
      $(this.navigationTarget).css('width', this.navWidth);

      if ($(this.element).hasClass(COLLAPSED_CLASS)) {
        this.toggleNavigation(false, false);
      }
    }

    if (Modernizr.mq('(max-width: 991px)')) {
      this.$navToggler.on('click', () => {
        const isOpen = this.$navToggler.attr('aria-expanded') !== 'true';

        $(this.element).toggleClass('is-open', isOpen);
      });
    }
  }

  throttledScroll() {
    throttle(this.scroll(), 40);
  }

  scroll() {
    const top = $(window).scrollTop();

    if (top > $(this.element).height() && !$(this.element).hasClass('is-scrolled')) {
      $(this.element).addClass('is-scrolled');
      this.toggleNavigation(false, false);
    } else if (top <= $(this.element).height() && $(this.element).hasClass('is-scrolled')) {
      $(this.element).removeClass('is-scrolled');
      this.toggleNavigation(true, false);
    }
  }

  toggleNavigation(state = true, triggerScroll = true) {
    if (Modernizr.mq('(max-width: 991px)')) {
      return;
    }

    this.$navToggler.attr('aria-expanded', state);

    if (triggerScroll) {
      $(this.element).toggleClass('is-scrolled', state);
    }

    $(this.navigationTarget).animate({
      width: state ? this.navWidth : COLLAPSED_WIDTH,
      opacity: state ? EXPANDED_OPACITY : 0,
    }, ANIMATION_SPEED);
  }
}

Header.targets = [
  'navigation',
];

export default Header;
